import { Card, Text } from '@clockout-dev/design-elements';
import styles from './styles/sectionCard.module.scss';

export default function SectionCard({ icon, title, action, children }) {
    return (
        <Card className={styles.sectionCard}>
            <div className={styles.cardHeader}>
                {icon ? <div className={styles.cardHeaderIcon}>{icon}</div> : null}
                <Text as="span" size="s" className={styles.cardHeaderTitle}>
                    {title}
                </Text>
                {action}
            </div>
            {children}
        </Card>
    );
}
